module.exports = {
  ACCEPTED: 'accepted',
  PENDING: 'pending',
  FAILED: 'failed',
  SUCCESS: 'success',
};
